import { Component } from '@theme/component';

/**
 * Het zoekveld in het mobiele menu: sluit het menu en opent de zoekmodal,
 * zodat er niet twee panelen op elkaar liggen.
 */
class MenuDrawerSearch extends Component {
  async open() {
    const drawer = /** @type {import('@theme/theme-drawer').ThemeDrawer | null} */ (this.closest('theme-drawer'));
    const search = /** @type {(HTMLElement & { showDialog?: () => void }) | null} */ (
      document.getElementById('search-modal')
    );
    await drawer?.close();
    search?.showDialog?.();
  }
}

if (!customElements.get('menu-drawer-search-component')) {
  customElements.define('menu-drawer-search-component', MenuDrawerSearch);
}
